import React, { useEffect, useState , useRef } from 'react';
import { FormControl, FormHelperText, Radio, TextField } from "@mui/material";
import "./PracticeAssignmentPopup.css";
import OutlinedInput from '@mui/material/OutlinedInput';
import InputLabel from '@mui/material/InputLabel';
import MenuItem from '@mui/material/MenuItem';
import ListItemText from '@mui/material/ListItemText';
import Select from '@mui/material/Select';
import { toast } from "react-toastify";
import Checkbox from '@mui/material/Checkbox';
import { useLocation, useNavigate } from 'react-router';
import {
    arrow_Forward_whiteee,
    benefits_practice_assignments_image_1,
    benefits_practice_assignments_image_2,
    benefits_practice_assignments_image_3,
    benefits_practice_assignments_image_4,
    benefits_practice_assignments_image_5,
    benefits_practice_assignments_image_6
} from "../../../../../../../assets/images/images";
import { useDispatch, useSelector } from 'react-redux';
import { generatePracticeAssignment, resetGeneratePracticeAssignment } from '../../../../../../../state/actions/generatePracticeAssignmentAction'
import { AssignmentType } from "../../../../../../../utils/consts";
import { useAuth } from '../../../../../../../features/auth/AuthContext';
import { getPracticeAssignments } from "../../../../../../../state/actions/getPracticeAssignmentsAction";
import Modal from 'react-responsive-modal';
import { getAssignmentsByLesson } from '../../../../../../../state/actions/getAssignmentsByLessonAction';
import PracticeAssignmentRazorpayCheckout from '../../../../../../../components/PaymentStrip/PracticeAssignmentRazorpayCheckout';
import { Ring } from '@uiball/loaders';

const getAssignmentTypeName = (type) => {
    return Object.values(AssignmentType).find((item) => {
        return item.value === type;
    })?.name;
};


const assignmentTypes = [
    'Multiple Choice Questions',
    'True/False',
    'Fill in the Blanks',
    'Short Answer Questions',
    'Essay Questions',
    'Mixed',
    'Other',
];


const difficultyLevels = [
    { label: 'Easy', value: 1 },
    { label: 'Moderate', value: 2 },
    { label: 'Difficult', value: 3 },
];

const ITEM_HEIGHT = 48;
const ITEM_PADDING_TOP = 8;
const MenuProps = {
    PaperProps: {
        style: {
            maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
            width: 250,
        },
    },
};

const assignmentTypeMapping = {
    'MIX': 'Mixed Questions',
    'MCQ': 'Multiple Choice Questions',
    'Fill-In-The-Blanks': 'Fill In The Blanks',
    'Short-Answer-Questions': 'Short Answer Questions',
    'Essay-Questions': 'Essay Questions',
    'True/False': 'True/False'
};

function PracticeAssignmentPopup({ assignment, onClose, setShowPopup, setshowScorePopup, setShowCongratulations, setcallWebSocket, callWebSocket, setwebsocketPayload, isNaviget,setshowscore,setHideScorePopup  }) {

    const navigate = useNavigate();
    const location = useLocation();
    const dispatch = useDispatch();
    const course = location?.state?.course;
    const lesson = location?.state?.lesson;
    const { token } = useAuth();
    const lessonName = location?.state?.lesson.name;
    const courseName = location?.state?.course.name;
    const courseId = location?.state?.course.course_id;
    const lessonId = location?.state?.lesson.lesson_id;
    const [personName, setPersonName] = React.useState([]);
    const [selectedAssignmentType, setSelectedAssignmentType] = useState('');
    const [selectedDifficultyLevel, setSelectedDifficultyLevel] = useState('');
    const [submissionId, setSubmissionId] = useState(assignment?.submission?.submission_id || null);
    const [practiceId, setPracticeId] = useState(null);
    const generatepracticeassignment = useSelector((state) => state.generatePracticeAssignment);
    const [openDialog, setOpenDialog] = useState(false);
    const [item_id, setitem_id] = useState();
    const [clickDisabled, setClickDisabled] = useState(false);
    const [proceedtoPay, setProceedtopay] = useState(false);
    const globalState = useSelector((state) => state.globalState);
    const currency_symbol = useSelector((state) => state?.globalState?.currency_symbol)
    const [showBillingPopup, setShowBillingPopup] = useState(false);
    const [showRazorpay, setShowRazorpay] = useState(false);
    const loc = useSelector((state) => state?.globalState?.student_details?.data?.location)
    const getLocation = loc.split(",").pop().trim();
    const Location = getLocation ? getLocation : "India";
    const isIndia = Location === "India";
    let price = isIndia ? 99 : 1;
    const [loading, setloading] = useState(false)
    const isMarketplace = globalState.enabled_modules?.includes("marketplace");
    const [hidePopups, setHidePopups] = useState(false);




    const handleAssignmentTypeChange = (event) => {
        setSelectedAssignmentType(event.target.value);
    };

    const handleDifficultyLevelChange = (event) => {
        setSelectedDifficultyLevel(event.target.value);
    };

    const [formErrorAssignmentState, setFormErrorAssignmentState] = useState({});
    // const [showCongratulations, setShowCongratulations] = useState(false);


    // const handleProceedToPay = async (assignment) => {
    //     setClickDisabled(true)
    //     const payload = {
    //         assignment_id: assignment?.assignment_id,
    //         type: assignment?.type,
    //         level: 2,
    //         name: assignment?.name,
    //     };
    //     dispatch(generatePracticeAssignment(payload, token))
    // };
    const courseType = course?.course_type
    // console.log("courseType", courseType);


    // Pulls a usable YouTube URL out of either an <iframe ...> string or a plain URL.
    const extractYoutubeUrl = (value) => {
        if (!value || typeof value !== 'string') return null;

        const raw = value.trim();
        if (!raw) return null;

        // iframe markup -> read the src attribute
        if (raw.includes('<iframe')) {
            const match = raw.match(/src=["']([^"']+)["']/i);
            return match?.[1]?.trim() || null;
        }

        // plain URL
        return /^https?:\/\//i.test(raw) || raw.includes('youtu') ? raw : null;
    };

    /**
     * Walks assignment_json in order and returns the first usable youtube_url.
     * Breaks at the first hit (e.g. found on the 4th object -> stops there).
     * Returns null if no question in the array carries a video.
     */
    const getFirstYoutubeUrl = (assignmentJson) => {
        if (!Array.isArray(assignmentJson) || assignmentJson.length === 0) return null;

        for (const question of assignmentJson) {
            if (!question || typeof question !== 'object') continue; // skip malformed entries

            const url = extractYoutubeUrl(question.youtube_url);
            if (url) return url; // first valid match wins, loop ends
        }

        return null;
    };

    const handleclicktoproceed = () => {
        setShowBillingPopup(true)
    }





    const handlecheckout = async () => {
        if (isIndia) {
            setShowRazorpay(true);    //if you want razorpay 
            //setShowBillingPopup(false);
           // setHidePopups(true); 
            setHideScorePopup?.(true);   // hide the score popup too

        } else {
            navigate(`/Checkout`, {
                state: {
                    ...location.state,
                    ...assignmentCheckoutData,
                }
            });
            // console.log("h");

        }
    }

    // PROSCHOOL only: drop anything left over from the Stripe checkout page.
useEffect(() => {
    if (isMarketplace) dispatch(resetGeneratePracticeAssignment());
}, []);

    //for PROSCHOOL :for razorpay
    const handleProceedToPay = async (assignment) => {
        const youtubeUrl = getFirstYoutubeUrl(assignment?.assignment_json);
        if (clickDisabled) return; // Prevent multiple clicks
        setClickDisabled(true);
        const payload = {
            assignment_id: assignment?.assignment_id,
            type: assignment?.type,
            level: 2,
            name: assignment?.name,
            ...(youtubeUrl && { youtube_url: youtubeUrl }),
        };

        try {
            const result = await dispatch(generatePracticeAssignment(payload, token, courseType));
            // console.warn("generatePracticeAssignment result:", result);
            if (result?.data?.status === 200) {
                setTimeout(() => {
                    dispatch(getAssignmentsByLesson(lessonId, 1, token, courseType));
                }, 2000)
            }


            localStorage.removeItem(`congratulationMessgaePopUp${assignment.id ? assignment.id : assignment.assignment_id}${token}`);
            localStorage.removeItem(`getSubmissiondtlsData${assignment.id ? assignment.id : assignment.assignment_id}${token}`);
            localStorage.removeItem(`timerSeconds${assignment.id ? assignment.id : assignment.assignment_id}${token}`);
            localStorage.removeItem(`assignmentTimers${assignment.id ? assignment.id : assignment.assignment_id}${token}`);
            localStorage.removeItem(`studentAssignmentProgressOnSelect${assignment.id ? assignment.id : assignment.assignment_id}${token}`);
            localStorage.removeItem(`studentAssignmentProgressDtls${assignment.id ? assignment.id : assignment.assignment_id}${token}`);
            localStorage.removeItem(`sAPDtls_AssignmentId${assignment.id ? assignment.id : assignment.assignment_id}${token}`);
            localStorage.removeItem(`studentWholeAssignmentProgressDtls${assignment.id ? assignment.id : assignment.assignment_id}${token}`);
            localStorage.removeItem(`studentAssignmentProgressCurrentStep${assignment.id ? assignment.id : assignment.assignment_id}${token}`);
            localStorage.removeItem(`studentAssignmentProgressCurrentStepForQuestion${assignment.id ? assignment.id : assignment.assignment_id}${token}`);

        } catch (error) {
            console.error('Error generating practice assignment or fetching assignments:', error);
        } finally {
            setClickDisabled(false);
        }
    };





    //bb proschool first assingment free
    const MAX_PRACTICE = 10; // total allowed per assignment
    const remaining = assignment?.practice_assignment_remaining_count ?? 0;
    const isFirstPracticeFree = remaining === MAX_PRACTICE; // untouched → first is free
    const noneRemaining = remaining <= 0;


    //for SRDS free assignment, we will directly generate the practice assignment without going to checkout page. So we need to create a new function for that.
    const handleProceedToAssignment = async (assignment) => {

        const youtubeUrl = getFirstYoutubeUrl(assignment?.assignment_json);

        if (clickDisabled) return; // Prevent multiple clicks
        setClickDisabled(true);
        const payload = {
            assignment_id: assignment?.assignment_id,
            type: assignment?.type,
            level: 2,
            name: assignment?.name,
            ...(youtubeUrl && { youtube_url: youtubeUrl }),
        };

        try {
            const result = await dispatch(generatePracticeAssignment(payload, token, courseType));

            if (result?.data?.status === 200) {
                setTimeout(() => {
                    dispatch(getAssignmentsByLesson(lessonId, 1, token, courseType));
                }, 2000)
            }


            localStorage.removeItem(`congratulationMessgaePopUp${assignment.id ? assignment.id : assignment.assignment_id}${token}`);
            localStorage.removeItem(`getSubmissiondtlsData${assignment.id ? assignment.id : assignment.assignment_id}${token}`);
            localStorage.removeItem(`timerSeconds${assignment.id ? assignment.id : assignment.assignment_id}${token}`);
            localStorage.removeItem(`assignmentTimers${assignment.id ? assignment.id : assignment.assignment_id}${token}`);
            localStorage.removeItem(`studentAssignmentProgressOnSelect${assignment.id ? assignment.id : assignment.assignment_id}${token}`);
            localStorage.removeItem(`studentAssignmentProgressDtls${assignment.id ? assignment.id : assignment.assignment_id}${token}`);
            localStorage.removeItem(`sAPDtls_AssignmentId${assignment.id ? assignment.id : assignment.assignment_id}${token}`);
            localStorage.removeItem(`studentWholeAssignmentProgressDtls${assignment.id ? assignment.id : assignment.assignment_id}${token}`);
            localStorage.removeItem(`studentAssignmentProgressCurrentStep${assignment.id ? assignment.id : assignment.assignment_id}${token}`);
            localStorage.removeItem(`studentAssignmentProgressCurrentStepForQuestion${assignment.id ? assignment.id : assignment.assignment_id}${token}`);

        } catch (error) {
            console.error('Error generating practice assignment or fetching assignments:', error);
        } finally {
            setClickDisabled(false);
        }
    };



    const isButtonDisabled = !selectedAssignmentType || !selectedDifficultyLevel;

    useEffect(() => {
        if (generatepracticeassignment.error === 'You cannot generate more than 2 practice assignments for this assignment.') {
            toast.error(generatepracticeassignment.error)
            return;
        }
        if (generatepracticeassignment.practice_assignment_id) {
            if (isNaviget == true) {
                setshowScorePopup(false);
                setShowCongratulations(true);
                setTimeout(() => {
                    navigate(`/course/${courseId}/lesson/${lessonId}/overview`, {
                        state: {
                            courseId: courseId,
                            lessonId: lessonId,
                            course: course,
                            lesson: lesson,
                            activeTab: "Assignments",
                            submission_id: assignment.submission.submission_id,
                            practice_id: generatepracticeassignment.practice_assignment_id,
                            assignment_id: assignment.assignment_id,
                        }
                    });
                }, 2150)


                return;
            }
            setcallWebSocket(!callWebSocket)


            setShowPopup(false);
            setshowScorePopup(false);
            setwebsocketPayload((prev) => {
                return {
                    ...prev,
                    practice_id: generatepracticeassignment.practice_assignment_id,
                };
            })
            setPracticeId(generatepracticeassignment.practice_assignment_id); // Set the practice_id
            setShowCongratulations(true);

        }

        return () => dispatch(resetGeneratePracticeAssignment());

        // const assignJson = {
        //     submission_id: assignment?.submission?.submission_id,
        //     level: selectedDifficultyLevel,
        //     type: selectedAssignmentType,
        // }

    }, [generatepracticeassignment])

    const close = (id) => {
        setitem_id(id)
        setOpenDialog(!openDialog); // This will close the popup
    };

    // Map the assignment type to its corresponding display name
    const assignmentType = assignment?.assignment_type;
    const displayAssignmentType = assignmentTypeMapping[assignmentType] || assignmentType;

    const assignmentCheckoutData = {
        assignment,
        isAssignment: true,
        displayAssignmentType,
        lessonName,
        courseName,
        courseId,
        lessonId,
        price,
        courseType
    };


    return (
        <>
            {!hidePopups &&!showBillingPopup && <div className="popup-wrapper">
                <div className="popup-container">
                    <div className="practice-assignment-popup">
                        {/* <h2>Review Assignment : <span>{assignment?.name}</span></h2> */}
                        <h2>Practice Assignment : <span>{assignment?.name}</span></h2>
                        <p><span>Course:</span> {courseName}</p>
                        <p><span>Lesson:</span> {lessonName}</p>
                        <p><span>Assignment type:</span> {displayAssignmentType} </p>
                        <div className="practice-assignment-input-folder">
                            {/* <div className="practice-assignment-inner-input">
                                <label>Assignment type</label>
                                <FormControl margin="none">
                                    <Select
                                        value={selectedAssignmentType}
                                        onChange={handleAssignmentTypeChange}
                                        displayEmpty
                                        renderValue={(selected) => {
                                            if (!selected) {
                                                return <p className='select-assignment-type'>Select assignment type</p>;
                                            }
                                            return Object.values(AssignmentType).find(type => type.value === selected)?.name;
                                        }}
                                        MenuProps={MenuProps}
                                        sx={{
                                            height: 42,
                                            "& .MuiInputBase-input": {
                                                height: "30px",
                                                padding: "6px 14px",
                                            },
                                            "& .MuiOutlinedInput-root": {
                                                borderRadius: "4px",
                                                fontSize: "14px",
                                                fontWeight: 400,
                                                fontFamily: "inherit",
                                                background: "rgba(248, 248, 248, 1)",
                                            },
                                        }}
                                    >
                                        {Object.values(AssignmentType).map((type) => (
                                            <MenuItem key={type.name} value={type.value}>
                                                <ListItemText primary={type.name} />
                                                <Radio checked={selectedAssignmentType === type.value} />
                                            </MenuItem>
                                        ))}
                                    </Select>
                                </FormControl>
                            </div>

                            <div className="practice-assignment-inner-input">
                                <label>Difficulty Level</label>
                                <FormControl>
                                    <Select
                                        value={selectedDifficultyLevel}
                                        onChange={handleDifficultyLevelChange}
                                        displayEmpty
                                        renderValue={(selected) => {
                                            if (!selected) {
                                                return <p className='select-difficulty-level'>Select difficulty level</p>;
                                            }
                                            return difficultyLevels.find(level => level.value === selected)?.label;
                                        }}
                                        MenuProps={MenuProps}
                                        sx={{
                                            height: 42,
                                            "& .MuiInputBase-input": {
                                                height: "30px",
                                                padding: "6px 14px",
                                            },
                                            "& .MuiOutlinedInput-root": {
                                                borderRadius: "4px",
                                                fontSize: "14px",
                                                fontWeight: 400,
                                                fontFamily: "inherit",
                                                background: "rgba(248, 248, 248, 1)",
                                            },
                                        }}
                                    >
                                        {difficultyLevels.map((level) => (
                                            <MenuItem key={level.value} value={level.value}>
                                                <ListItemText primary={level.label} />
                                                <Radio checked={selectedDifficultyLevel === level.value} />
                                            </MenuItem>
                                        ))}
                                    </Select>
                                </FormControl>
                            </div> */}
                        </div>
                        <div className='benefits-practice-assignments-feature-container'>
                            {/* <h2 className='benefits-practice-assignments-feature-title'>Benefits of the "Review Assignments" Feature:</h2> */}
                            <h2 className='benefits-practice-assignments-feature-title'>Benefits of the "Practice Assignment" Feature:</h2>
                            <div className='benefits-practice-assignments-feature-folder'>
                                <div className='benefits-practice-assignments-inner-feature-folder'>
                                    <div className='benefits-practice-assignments-image'>
                                        <img src={benefits_practice_assignments_image_1} />
                                    </div>
                                    <h2>Personalized Learning: <span>Tailor assignments based on past performance.</span></h2>
                                </div>
                                <div className='benefits-practice-assignments-inner-feature-folder'>
                                    <div className='benefits-practice-assignments-image'>
                                        <img src={benefits_practice_assignments_image_2} />
                                    </div>
                                    <h2>Skill Improvement: <span>Focus on areas needing more practice.</span></h2>
                                </div>
                                {/* <div className='benefits-practice-assignments-inner-feature-folder'>
                                    <div className='benefits-practice-assignments-image'>
                                        <img src={benefits_practice_assignments_image_3} />
                                    </div>
                                    <h2>Flexible Difficulty Levels: <span>Choose difficulty to match your skills</span></h2>
                                </div> */}
                                <div className='benefits-practice-assignments-inner-feature-folder'>
                                    <div className='benefits-practice-assignments-image'>
                                        <img src={benefits_practice_assignments_image_4} />
                                    </div>
                                    <h2>Self-Paced Progress: <span>Complete assignments at your own pace.</span></h2>
                                </div>
                                <div className='benefits-practice-assignments-inner-feature-folder'>
                                    <div className='benefits-practice-assignments-image'>
                                        <img src={benefits_practice_assignments_image_5} />
                                    </div>
                                    <h2>Enhanced Subject Mastery: <span>Target specific subjects for better mastery</span></h2>
                                </div>
                                <div className='benefits-practice-assignments-inner-feature-folder'>
                                    <div className='benefits-practice-assignments-image'>
                                        <img src={benefits_practice_assignments_image_6} />
                                    </div>
                                    <h2>Performance Tracking: <span>Monitor progress and improvement over time</span></h2>
                                </div>
                            </div>
                        </div>

                        {globalState.enabled_modules?.includes("marketplace") ? (
                            noneRemaining ? (
                                <button
                                    type="button"
                                    className="practice-assignment-button"
                                    disabled
                                    style={{ backgroundColor: 'gray' }}
                                >
                                    No practice assignments remaining
                                </button>
                            ) : isFirstPracticeFree ? (
                                <button
                                    type="button"
                                    className="practice-assignment-button"
                                    onClick={() => handleProceedToAssignment(assignment)}
                                    disabled={clickDisabled}
                                    style={{ backgroundColor: '#0068FF' }}
                                >
                                    Proceed — First one free
                                </button>
                            ) : (<button
                                type="button"
                                className="practice-assignment-button"
                                onClick={handleclicktoproceed}
                                disabled={clickDisabled}
                                style={{ backgroundColor: '#0068FF' }}
                            > {loading ? (
                            <Ring size={23} color ={"#40f399"} />              ) : (<>
                                Proceed To Checkout: {currency_symbol}{price} </>)}
                            </button>)


                        ) : (
                            <button
                                type="button"
                                className="practice-assignment-button"
                                onClick={() => handleProceedToAssignment(assignment)}
                                disabled={clickDisabled}
                                style={{ backgroundColor: '#0068FF' }}
                            >
                                Proceed
                            </button>
                        )}
                    </div>
                    <span className="practice-assignment-close" onClick={onClose}><i class="fa-solid fa-x"></i></span>



                </div>
            </div>}
            {!hidePopups && showBillingPopup && (
                <div className="fixed inset-0 z-[113] bg-[#353535]/50 flex items-center justify-center">
                    <div className="relative w-full max-w-[560px] mx-4 bg-white rounded-xl shadow-lg">

                        {/* Header */}
                        <div className="flex items-center justify-between px-6 pt-5 pb-3">
                            <h2 className="text-[16px] font-semibold text-gray-900 m-0">
                                Practice Assignment : <span className="font-semibold">{assignment?.name}</span>
                            </h2>
                            <button
                                type="button"
                                onClick={() => setShowBillingPopup(false)}
                                className="text-gray-500 hover:text-gray-800 text-[14px] leading-none bg-transparent border-none cursor-pointer"
                                aria-label="Close"
                            >
                                <i className="fa-solid fa-x"></i>
                            </button>
                        </div>

                        {/* Billing Summary */}
                        <div className="px-6">
                            <h3 className="text-[14px] font-semibold text-gray-900 mb-2">Billing Summary</h3>

                            <div className="flex items-start justify-between">
                                <div className="space-y-[2px]">
                                    <p className="text-[13px] text-[#707070] m-0">Course : {courseName}</p>
                                    <p className="text-[13px] text-[#707070] m-0">Lesson : {lessonName}</p>
                                    <p className="text-[13px] text-[#707070] m-0">Assignment : {displayAssignmentType}</p>
                                </div>
                                <span className="text-[13px] text-gray-700">{currency_symbol} {price}</span>
                            </div>

                            {/* Spacer to match the tall empty area in the design */}
                            <div className="h-24"></div>

                            {/* Divider */}
                            <div className="border-t border-gray-200"></div>

                            {/* Total row */}
                            <div className="flex items-center justify-between py-3">
                                <span className="text-[14px] font-semibold text-gray-900">Total</span>
                                <span className="text-[14px] font-bold text-gray-900">{currency_symbol} {price}</span>
                            </div>
                        </div>

                        {/* Footer */}
                        <div className="flex items-center justify-between px-6 pb-5 pt-1">
                            <button
                                type="button"
                                onClick={() => setShowBillingPopup(false)}
                                className="flex items-center gap-1 text-[13px] text-[#0068FF] bg-transparent border-none cursor-pointer hover:underline"
                            >
                                <span className="text-[11px]">&lt;</span> Back
                            </button>

                            <button
                                type="button"
                                onClick={() => handlecheckout(assignment)}
                                disabled={clickDisabled}
                                className="flex items-center gap-2 bg-[#0068FF] text-white text-[13px] font-medium px-5 py-2 rounded-md border-none cursor-pointer hover:bg-[#0057d6] disabled:opacity-60 disabled:cursor-not-allowed"
                            >
              {loading ? (
<Ring size={23} color ={"#40f399"} />              ) : (
                <>
                  {" "}
                  Proceed to Checkout{" "} 
                  <img
                    src={arrow_Forward_whiteee}
                    alt="checkout"
                    style={{ width: "13px", height: "18px", marginLeft: "8px" }}
                  />{" "}
                </>
              )}
                            </button>


                        </div>
                    </div>
                </div>)}


            {showRazorpay && (
                <PracticeAssignmentRazorpayCheckout
                    onClose={() => {setShowRazorpay(false); setHidePopups(false);  setHideScorePopup?.(false); }}
                    setloading={setloading}
                            setHidePopups={setHidePopups}          // new
        setHideScorePopup={setHideScorePopup}  // new
                    assignmentCheckoutData={assignmentCheckoutData}
                    onPaymentSuccess={() => handleProceedToPay(assignment)}  // popup's own helper

                />
            )}
        </>
    )
}

export default PracticeAssignmentPopup;